import Vue from 'vue';

Vue.directive('visible', (el, binding) => {
  // eslint-disable-next-line no-param-reassign
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});
